import { useEffect } from 'react'
import localFont from 'next/font/local'

import { useLoaderStore } from '@/store/loader'

const helveticanow = localFont({
  src: [
    {
      path: './fonts/HelveticaNowDisplay-Light.woff2',
      weight: '300',
      style: 'normal'
    },
    {
      path: './fonts/HelveticaNowDisplay-Regular.woff2',
      weight: '400',
      style: 'normal'
    },
    {
      path: './fonts/HelveticaNowDisplay-Bold.woff2',
      weight: '700',
      style: 'normal'
    }
  ]
})

const helvetica = localFont({
  src: [
    {
      path: './fonts/helvetica-neue-light.woff',
      weight: '300',
      style: 'normal'
    },
    {
      path: './fonts/helvetica-neue-regular.woff',
      weight: '400',
      style: 'normal'
    },
    {
      path: './fonts/helvetica-neue-medium.woff',
      weight: '500',
      style: 'normal'
    },
    {
      path: './fonts/helvetica-neue-bold.woff',
      weight: '700',
      style: 'normal'
    }
  ]
})

export type ThemeProps = Partial<{
  fluid: boolean
}>

const Theme = ({ fluid = false }: ThemeProps) => {
  const setLoaderState = useLoaderStore((state) => state.setState)

  useEffect(() => {
    document.fonts.ready.then(() => {
      console.log('Fonts are ready')
      setLoaderState({ fontsReady: true })
    })
  }, [setLoaderState])

  return (
    <style jsx global>{
      /* css */ `
        :root {
          --font-family-helveticanow: ${helveticanow.style.fontFamily};
          --font-family-helvetica: ${helvetica.style.fontFamily};
          --font-size: ${fluid ? `clamp(10px, ${(10 / 1920) * 100}vw, 11.5px)` : `10px`};
        }
      `
    }</style>
  )
}

export default Theme
